import React from "react";

export default function NotificationBadge({ count = 0 }) {
  return (
    <>
      <div className="d-flex align-items-center gap-2">
        {count > 0 && <div className="countText">{count}</div>}
      </div>
    </>
  );
}
